import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Card, CardContent, Grid, FormControl, InputLabel, Select, MenuItem,
  Switch, FormControlLabel, Button, Table, TableHead, TableBody, TableRow, TableCell,
  TableContainer, IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions,
  Chip, Alert, Divider
} from '@mui/material';
import { Upload, Delete, PersonAdd } from '@mui/icons-material';
import { scholarAPI, formsAPI } from '../services/api';

export default function ScholarSettings(props) {
  var formId = props.formId;
  var settings = props.settings || {};
  var onSettingsChange = props.onSettingsChange;
  var formType = props.formType;
  var E = React.createElement;

  // Scholar list
  var sls = useState([]); var scholars = sls[0]; var setScholars = sls[1];
  var fls = useState([]); var scholarshipForms = fls[0]; var setScholarshipForms = fls[1];
  var ads = useState(false); var addOpen = ads[0]; var setAddOpen = ads[1];
  var ans = useState({name:'',email:''}); var addForm = ans[0]; var setAddForm = ans[1];
  var uls = useState(''); var uploadStatus = uls[0]; var setUploadStatus = uls[1];

  // Load scholars if CSV mode
  useEffect(function() {
    if (formId && settings.scholar_validation === 'csv') {
      scholarAPI.list(formId).then(function(r) { setScholars(r.data.data || []); }).catch(function(e) { console.error(e); });
    }
  }, [formId, settings.scholar_validation]);

  // Load scholarship forms for dropdown
  useEffect(function() {
    formsAPI.list('scholarship').then(function(r) {
      setScholarshipForms((r.data.data || []).filter(function(f) { return f.form_type === 'scholarship'; }));
    }).catch(function(e) { console.error(e); });
  }, []);

  function handleCSVUpload(e) {
    var file = e.target.files[0];
    if (!file) return;
    setUploadStatus('Uploading...');
    scholarAPI.upload(formId, file).then(function(r) {
      var d = r.data.data;
      setUploadStatus('Added ' + d.added + ' scholars' + (d.skipped > 0 ? ', ' + d.skipped + ' skipped (duplicates)' : ''));
      scholarAPI.list(formId).then(function(r2) { setScholars(r2.data.data || []); });
    }).catch(function(err) {
      setUploadStatus('Upload failed: ' + ((err.response && err.response.data && err.response.data.error) || 'unknown error'));
    });
  }

  function handleAddScholar() {
    scholarAPI.add(formId, addForm).then(function() {
      setAddOpen(false);
      setAddForm({name:'',email:''});
      scholarAPI.list(formId).then(function(r) { setScholars(r.data.data || []); });
    });
  }

  function handleRemoveScholar(scholarId) {
    if (!window.confirm('Remove this scholar?')) return;
    scholarAPI.remove(formId, scholarId).then(function() {
      setScholars(function(prev) { return prev.filter(function(s) { return s.id !== scholarId; }); });
    });
  }

  function updateSetting(key, value) {
    var next = Object.assign({}, settings);
    next[key] = value;
    onSettingsChange(next);
  }

  if (formType !== 'registration') return null;

  return E(Card, {sx:{mt:3, mb:3}},
    E(CardContent, null,
      E(Typography, {variant:'h6', sx:{mb:2, display:'flex', alignItems:'center', gap:1}}, 'Scholar Validation Settings'),

      E(Grid, {container:true, spacing:2},

        // Validation method
        E(Grid, {item:true, xs:12, md:4},
          E(FormControl, {fullWidth:true, size:'small'},
            E(InputLabel, null, 'Scholar Validation Method'),
            E(Select, {value: settings.scholar_validation || 'none', label:'Scholar Validation Method',
              onChange: function(e) { updateSetting('scholar_validation', e.target.value); }},
              E(MenuItem, {value:'none'}, 'None (open registration)'),
              E(MenuItem, {value:'csv'}, 'CSV Upload (name + email list)'),
              E(MenuItem, {value:'scholarship_form'}, 'From Scholarship Form Decisions')))),

        // Linked scholarship form (if scholarship_form mode)
        settings.scholar_validation === 'scholarship_form' ?
          E(Grid, {item:true, xs:12, md:4},
            E(FormControl, {fullWidth:true, size:'small'},
              E(InputLabel, null, 'Linked Scholarship Form'),
              E(Select, {value: settings.linked_scholarship_form || '', label:'Linked Scholarship Form',
                onChange: function(e) { updateSetting('linked_scholarship_form', e.target.value); }},
                scholarshipForms.map(function(f) {
                  return E(MenuItem, {key:f.id, value:f.id}, f.title);
                })))) : null,

        // Allow self-fund
        E(Grid, {item:true, xs:12, md:4},
          E(FormControlLabel, {
            control: E(Switch, {checked: !!settings.allow_self_fund,
              onChange: function(e) { updateSetting('allow_self_fund', e.target.checked); }}),
            label: 'Allow self-funded registration'
          }),
          E(Typography, {variant:'caption', color:'text.secondary', sx:{display:'block', ml:6, mt:-0.5}},
            'Non-scholars can register and see base fields (not scholar-only fields)'))
      ),

      // CSV upload section (if CSV mode)
      settings.scholar_validation === 'csv' ? E(Box, {sx:{mt:3}},
        E(Divider, {sx:{mb:2}}),
        E(Typography, {variant:'subtitle1', sx:{mb:2, fontWeight:600}}, 'Scholar List'),

        E(Box, {sx:{display:'flex', gap:2, mb:2, flexWrap:'wrap'}},
          E(Button, {variant:'outlined', component:'label', startIcon:E(Upload)},
            'Upload CSV',
            E('input', {type:'file', hidden:true, accept:'.csv', onChange:handleCSVUpload})),
          E(Button, {variant:'outlined', startIcon:E(PersonAdd), onClick:function(){setAddOpen(true);}}, 'Add Scholar'),
          E(Chip, {label:scholars.length + ' scholars', size:'small', color:'primary', variant:'outlined'})
        ),

        uploadStatus ? E(Alert, {severity: uploadStatus.includes('fail') ? 'error' : 'success', sx:{mb:2}, onClose:function(){setUploadStatus('');}}, uploadStatus) : null,

        E(Typography, {variant:'caption', color:'text.secondary', sx:{mb:1, display:'block'}},
          'CSV format: Name, Email (first row is skipped if it contains "Name" or "name")'),

        scholars.length > 0 ? E(TableContainer, {sx:{maxHeight:300}},
          E(Table, {size:'small', stickyHeader:true},
            E(TableHead, null,
              E(TableRow, null,
                E(TableCell, null, 'Name'),
                E(TableCell, null, 'Email'),
                E(TableCell, {width:50}, ''))),
            E(TableBody, null,
              scholars.map(function(s) {
                return E(TableRow, {key:s.id},
                  E(TableCell, null, s.name),
                  E(TableCell, null, s.email),
                  E(TableCell, null,
                    E(IconButton, {size:'small', color:'error', onClick:function(){handleRemoveScholar(s.id);}},
                      E(Delete, {fontSize:'small'}))));
              }))))
        : E(Typography, {variant:'body2', color:'text.secondary', sx:{py:2}}, 'No scholars uploaded yet. Upload a CSV or add manually.'),

        // Add scholar dialog
        E(Dialog, {open:addOpen, onClose:function(){setAddOpen(false);}, maxWidth:'xs', fullWidth:true},
          E(DialogTitle, null, 'Add Scholar'),
          E(DialogContent, {sx:{pt:'16px !important'}},
            E(TextField, {fullWidth:true, label:'Name', value:addForm.name, sx:{mb:2},
              onChange:function(e){setAddForm(Object.assign({},addForm,{name:e.target.value}));}}),
            E(TextField, {fullWidth:true, label:'Email', type:'email', value:addForm.email,
              onChange:function(e){setAddForm(Object.assign({},addForm,{email:e.target.value}));}})),
          E(DialogActions, null,
            E(Button, {onClick:function(){setAddOpen(false);}}, 'Cancel'),
            E(Button, {variant:'contained', onClick:handleAddScholar, disabled:!addForm.name || !addForm.email}, 'Add')))
      ) : null
    )
  );
}
